<template>
  <div>
    hi
    <component :is="icon" class="fill-current" />
  </div>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true
  }
})

const icon = defineAsyncComponent(
  () => import(/* @vite-ignore */ `src/assets/svgs/${props.name}.svg`)
)
</script>

<style lang="scss" scoped></style>
